<template>
  <Teleport to="body">
    <div v-if="visible" class="array-dlg-overlay" @click.self="emit('close')">
      <div class="array-dlg" role="dialog" aria-labelledby="array-dlg-title" @click.stop>
        <h4 id="array-dlg-title">阵列复制</h4>
        <p class="array-dlg-hint">
          保留原点对象生成副本（可撤销）。行/列间距指<strong>相邻物体外轮廓之间的净距</strong>；中心步长 = 物体在该方向的占地 + 净距。
        </p>
        <div class="array-dlg-grid">
          <label>行数 <input v-model.number="rows" type="number" min="1" max="50" step="1" /></label>
          <label>行净距（米）<input v-model.number="rowSpacing" type="number" min="0" max="500" step="0.5" /></label>
          <label>列数 <input v-model.number="cols" type="number" min="1" max="50" step="1" /></label>
          <label>列净距（米）<input v-model.number="colSpacing" type="number" min="0" max="500" step="0.5" /></label>
        </div>
        <div class="array-dlg-axis">
          <span class="axis-label">方向</span>
          <label><input v-model="axis" type="radio" value="x" /> X轴（列→X，行→Z）</label>
          <label><input v-model="axis" type="radio" value="z" /> Z轴（列→Z，行→X）</label>
        </div>
        <div class="array-dlg-actions">
          <button type="button" class="btn-cancel" @click="emit('close')">取消</button>
          <button type="button" class="btn-ok" @click="confirm">确定</button>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'
import type { ArrayGridAxis } from '../utils/arrayDuplicate'

const props = defineProps<{ visible: boolean }>()
const emit = defineEmits<{
  close: []
  confirm: [{ rows: number; cols: number; rowSpacing: number; colSpacing: number; axis: ArrayGridAxis }]
}>()

const rows = ref(3)
const cols = ref(4)
const rowSpacing = ref(5)
const colSpacing = ref(4)
const axis = ref<ArrayGridAxis>('x')

watch(
  () => props.visible,
  (v) => {
    if (v) {
      rows.value = 3
      cols.value = 4
      rowSpacing.value = 5
      colSpacing.value = 4
      axis.value = 'x'
    }
  }
)

function confirm() {
  const r = Math.min(50, Math.max(1, Math.floor(Number(rows.value)) || 1))
  const c = Math.min(50, Math.max(1, Math.floor(Number(cols.value)) || 1))
  const rs = Math.min(500, Math.max(0, Number(rowSpacing.value) || 0))
  const cs = Math.min(500, Math.max(0, Number(colSpacing.value) || 0))
  emit('confirm', { rows: r, cols: c, rowSpacing: rs, colSpacing: cs, axis: axis.value })
  emit('close')
}
</script>

<style scoped>
.array-dlg-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  z-index: 12000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.array-dlg {
  width: 360px;
  max-width: 96vw;
  background: #1a2434;
  border: 1px solid #3a4a60;
  border-radius: 10px;
  padding: 16px 18px;
  color: #c8d8f0;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.4);
}

.array-dlg h4 {
  margin: 0 0 8px;
  font-size: 15px;
  font-weight: 600;
}

.array-dlg-hint {
  margin: 0 0 14px;
  font-size: 11px;
  color: #7a8aa0;
  line-height: 1.4;
}

.array-dlg-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px 14px;
  margin-bottom: 14px;
}

.array-dlg-grid label {
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 11px;
  color: #9aaccc;
}

.array-dlg-grid input[type='number'] {
  background: #243040;
  border: 1px solid #3a4a60;
  border-radius: 4px;
  color: #e0f0ff;
  padding: 4px 8px;
  font-size: 12px;
}

.array-dlg-axis {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px 16px;
  margin-bottom: 16px;
  font-size: 12px;
}

.axis-label {
  color: #8899aa;
  margin-right: 4px;
}

.array-dlg-axis label {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
}

.array-dlg-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.btn-cancel,
.btn-ok {
  padding: 6px 16px;
  border-radius: 6px;
  font-size: 12px;
  cursor: pointer;
  border: 1px solid #3a4a60;
}

.btn-cancel {
  background: #243040;
  color: #aac;
}

.btn-ok {
  background: #1e4a8a;
  border-color: #4a9eff;
  color: #eef;
}
</style>
